import { render, staticRenderFns } from "./ResultBatch.vue?vue&type=template&id=50daf8c1&scoped=true&"
import script from "./ResultBatch.vue?vue&type=script&lang=js&"
export * from "./ResultBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50daf8c1",
  null
  
)

export default component.exports